/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import SignupCollectionAction from '../SignupCollectionAction';
import HomeTypeCollection from '../HomeTypeCollection';
import { setFormData } from '../../../actions/collection';
import i18n from '../../../i18n';
import CollectionFunnelEvents from '../../../utils/collectionFunnelEvents';

export const Step2Collection = (props) => {
    const [canContinue, setCanContinue] = useState(false);
    const navigate = useNavigate();

    const hasError = (error) => {
        setCanContinue(Boolean(!error));
    };

    const submitForm = (values) => {
        if (!_.isEmpty(values)) {
            if (_.isEmpty(props.formCollectionData)) {
                props.setFormData(values);
            } else if (
                !_.isEqual(values.detail, props.formCollectionData.detail) ||
                !_.isEqual(values.type, props.formCollectionData.type)
            ) {
                if (props.formCollectionData.address) {
                    const { address, location } = props.formCollectionData;
                    props.setFormData({ ...values, address, location });
                } else {
                    props.setFormData(values);
                }
            }
            navigate(location.pathname.replace(/[^/]*$/, 'step3'));
            CollectionFunnelEvents.funnelProgress(2);
        }
    };

    return (
        <>
            <div className="step2-container">
                <div className="step-circle">
                    <span>2</span>
                </div>
                <div className="step-title">
                    <h2>{i18n.t('collection:step_2_collection_title')}</h2>
                </div>
                <HomeTypeCollection
                    step={2}
                    data={props.formCollectionData}
                    submitForm={submitForm}
                    hasError={hasError}
                />
            </div>
            <SignupCollectionAction step={2} isValid={canContinue} />
        </>
    );
};

Step2Collection.propTypes = {
    setFormData: PropTypes.func,
    formCollectionData: PropTypes.object
};

const mapDispatchToProps = (dispatch) => ({
    setFormData: bindActionCreators(setFormData, dispatch)
});

const mapStateToProps = (state) => ({
    formCollectionData: state.collection.formCollection
});

export default connect(mapStateToProps, mapDispatchToProps)(Step2Collection);
